import { instance as axios, setJwtToken } from "../../config/AxiosInstance";

// ------------GET CMS DATA-------------
export const fetchCmsDataApi = async (data) => {
  const endPoint = `user/cms` + "?" + new URLSearchParams(data).toString();
  return await axios.get(endPoint, setJwtToken());
};

// ------------GET-FAQ-DATA-------------
export const fetchFaqListApi = async (data) => {
  const endPoint = `user/faq/list` + "?" + new URLSearchParams(data).toString();
  return await axios.get(endPoint, setJwtToken());
};

// ------------GET-FAQ-DATA-without-auth-------
export const fetchFaqApi = async (data) => {
  const endPoint = `public/faq/list` + "?" + new URLSearchParams(data).toString();
  return await axios.get(endPoint);
};

